import React, { ReactElement, useState } from "react";

import InfoTitle from "./InfoTitle";
import styles from "./InfoGroup.module.scss";

interface Props {
  children: ReactElement[];
  activeTabIndex?: number;
}

const InfoGroup: React.FC<Props> = ({ children, activeTabIndex }) => {
  const [selectedTab, setSelectedTab] = useState(
    activeTabIndex ? activeTabIndex : 0,
  );

  return (
    <div>
      <ul className={styles.contents}>
        {children.map((item, index) => (
          <InfoTitle
            key={index}
            title={item.props.title}
            to={item.props.to}
            index={index}
            activeIndex={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        ))}
      </ul>
      {children[selectedTab]}
    </div>
  );
};

export default InfoGroup;
